import React from "react";
import EngagementVideoPage from "../../ui/EngagementVideoPage";

const AgatsuShowcase = () => (
  <EngagementVideoPage
    title="Kindness Connect"
    videoUrl="https://www.youtube.com/embed/oTspkF-HZc8"
    videoTitle="Kindness Connect"
  >
    <p>
      During World Kindness Week 2025, KU was honoured to be featured by the Agatsu Foundation in an event that spotlighted leading nonprofit organisations contributing to community well-being across Mumbai. The showcase enabled students and visitors to engage deeply with each organisation&apos;s mission, fostering greater awareness and encouraging active participation in kindness-driven service.
    </p>
  </EngagementVideoPage>
);

export default AgatsuShowcase;
